<template>
  <div class="p-4">
    <el-button icon="el-icon-close" size="small" v-if="showDeleteAll"
               @click="clearSelection()">Clear Selection</el-button>&nbsp;&nbsp;
    <el-button icon="el-icon-delete" type="danger" size="small" v-if="showDeleteAll"
               @click="deleteMultiple">Delete Selected</el-button>
    <button @click="newDeliveryMethod" class="float-right border-2 border-blue-500 text-blue-500 font-bold py-2 px-4 rounded">
      New Delivery Method
    </button>
    <el-table
      ref="delMethodTable"
      :data="delivery_methods.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%"
      @select-all="handleAllRowSelection"
      @select="handleRowSelection">
      <el-table-column
        type="selection">
      </el-table-column>
      <el-table-column
        prop="name"
        label="Name"
        sortable>
      </el-table-column>
      <el-table-column
        label="Shipper"
        prop="shipper_id"
        sortable>
      </el-table-column>
      <el-table-column
        prop="default"
        label="Default">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.default"></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="Status">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status"></el-switch>
        </template>
      </el-table-column>
      <el-table-column align="right" fixed="right">
        <template slot="header" slot-scope="scope">
          <el-input
            v-model="search"
            size="mini"
            placeholder="Type to search"/>
        </template>
        <template slot-scope="scope">
          <el-button @click="viewDeliveryMethod(scope.row.id)" type="text" size="small">
            <i class="text-xl text-gray-500 el-icon-view mr-1"></i>
          </el-button>
          <el-button @click="editDeliveryMethod(scope.row.id)" type="text" size="small">
            <i class="text-xl el-icon-edit-outline mr-4"></i>
          </el-button>
          <el-button @click="deleteDeliveryMethod(scope.row.id)" type="text" size="small">
            <i class="text-xl text-red-500 el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-5 mb-5 float-right"
      background
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handlePageChange"
      :current-page="pagination.page"
      :page-size="pagination.perPage"
      :page-count="pagination.lastPage"
      :total="pagination.total">
    </el-pagination>
  </div>
</template>

<script>

import { flatMap } from 'lodash';

export default {
  name: 'DeliveryMethods',
  data() {
    return {
      search: '',
      page: 1,
      limit: 20,
      showDeleteAll: false,
    };
  },
  computed: {
    delivery_methods() {
      return flatMap(this.$store.state.SettingsModule.DeliveryMethods.delivery_methods);
    },
    pagination() {
      return this.$store.state.SettingsModule.DeliveryMethods.pagination;
    },
  },
  mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
  },
  methods: {
    handleRowSelection() {
      this.showDeleteAll = this.$refs.delMethodTable.selection.length > 0;
    },
    handleAllRowSelection() {
      this.showDeleteAll = this.$refs.delMethodTable.selection.length > 0;
    },
    clearSelection() {
      this.$refs.delMethodTable.clearSelection();
      this.showDeleteAll = false;
    },
    newDeliveryMethod() {
      this.$router.push('/ecommerce/settings/delivery-methods/new');
    },
    viewDeliveryMethod(id) {
      this.$router.push(`/ecommerce/settings/delivery-methods/${id}/details`);
    },
    editDeliveryMethod(id) {
      this.$router.push(`/ecommerce/settings/delivery-methods/${id}/edit`);
    },
    deleteDeliveryMethod(deliveryMethodId) {
      this.$confirm('Are you sure you want to delete this delivery method?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('SettingsModule/DeliveryMethods/deleteDeliveryMethod', { deliveryMethodId });
          this.$notify.success({
            title: 'Success',
            message: 'Delivery method has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
    deleteMultiple() {
      const selected = this.$refs.delMethodTable.selection.map(deliveryMethod => deliveryMethod.id);
      this.$confirm('Are you sure you want to delete this delivery method?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          selected.forEach((deliveryMethodId) => {
            this.$store.dispatch('SettingsModule/DeliveryMethods/deleteDeliveryMethod', { deliveryMethodId });
          });
          this.$notify.success({
            title: 'Success',
            message: 'Delivery method has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
        this.clearSelection();
      });
    },
    getDeliveryMethods() {
      try {
        this.$store.dispatch('SettingsModule/DeliveryMethods/fetchAllDeliveryMethods', { page: this.page, limit: this.limit });
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
    },
    handleSizeChange(args) {
      this.limit = args;
      this.getDeliveryMethods();
    },
    handlePageChange(args) {
      this.page = args;
      this.getDeliveryMethods();
    },
  },
};
</script>

<style scoped>

</style>
